import styled from 'styled-components'
import BackgroundLines from '../../assets/Lines/background-lines.png'

export const LinesContainer = styled.div`
  padding-top: 56px;
  width: 100%;
  background-image: url(${BackgroundLines});

  h1{
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 56px;

    @media (max-width: 550px) {
      /* Phones */
      margin-bottom: 24px;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      margin-bottom: 24px;
    }
  }

  span{
    color: #EA0B2A;
  }
`

export const LogosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  margin-bottom: 56px;
  justify-items: center;
  width: 100%;

  @media (max-width: 550px) {
    /* Phones */
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1100px) {
    /* Tablets */
    grid-template-columns: repeat(2, 1fr);
  }

  img{
    width: 170px;
    margin-left: 0px;

      @media (max-width: 550px) {
    /* Phones */
    width: 100px;
    margin-top: 20px;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 100px;
    margin-top: 20px;
  }
  }
`
export const Container = styled.div`
  max-width: 1500px;
  margin: 0 auto;
`